export default function SelectTemplateLoader({ count, fullWidth, sklettenMargen, sklettenPading }) {
   return Array(count)
      .fill()
      .map((o, index) => (
         <div
            key={index}
            style={{ width: fullWidth }}
            className={`seletion-shade-list demo-view mt-${sklettenMargen} pt-${sklettenPading}`}
         />
      ));
}
